import { FC, useEffect, useMemo, PropsWithChildren } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { pageChanged } from '../../reducers';

type Props = PropsWithChildren<{ pathsToTrack: string[] }>;

const PageChangeTracker: FC<Props> = ({ pathsToTrack, children }) => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const paths = useMemo(() => new Set<string>(pathsToTrack), [pathsToTrack]);

  useEffect(() => {
    if (paths.has(pathname)) {
      dispatch(pageChanged());
    }
  }, [pathname, dispatch, paths]);

  return <>{children}</>;
};

export { PageChangeTracker };
